import { render, staticRenderFns } from "./CustomerWindow.vue?vue&type=template&id=14941fe4&scoped=true&"
import script from "./CustomerWindow.vue?vue&type=script&lang=js&"
export * from "./CustomerWindow.vue?vue&type=script&lang=js&"
import style0 from "./CustomerWindow.vue?vue&type=style&index=0&id=14941fe4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14941fe4",
  null
  
)

export default component.exports